export const separateNumber = (inputvalue, maxLength) => {
  const value = inputvalue;
  const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');

  const regex = new RegExp(`\\d{4,${maxLength}}`, 'g');

  const matches = v.match(regex);
  const match = (matches && matches[0]) || '';
  const parts = [];

  for (let i = 0, len = match.length; i < len; i += 4) {
    parts.push(match.substring(i, i + 4));
  }

  if (parts.length) {
    return parts.join(' ');
  }
  return value;
};

export const reformatNumber = inputvalue => {
  const value = inputvalue || '';
  return value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
};

export const formatNumber = number =>
  number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');

export const parseNumber = string =>
  parseInt(string.split('.').join(''), 10) || 0;

export const capitalizeWord = string => {
  const words = string
    .trim()
    .toLowerCase()
    .split(' ');
  const capitalized = [];
  words.forEach(word => {
    if (word.length) {
      capitalized.push(word[0].toUpperCase() + word.slice(1));
    }
  });

  return capitalized.join(' ');
};
